const DELAY_SECONDS = 5

function getConfirmBox() {
  return document.querySelector('.el-message-box.order-delete-confirm')
}

function getBoxVm() {
  const box = getConfirmBox()
  if (!box) return null
  let node = box
  while (node) {
    const vm = node.__vue__
    if (vm && typeof vm.confirmButtonText !== 'undefined') return vm
    node = node.parentNode
  }
  return null
}

function lockButton(locked) {
  const box = getConfirmBox()
  if (!box) return
  const btn = box.querySelector('.el-message-box__btns .el-button--primary')
  if (!btn) return
  if (locked) {
    btn.setAttribute('disabled', 'disabled')
  } else {
    btn.removeAttribute('disabled')
  }
}

/**
 * 删除订单二次确认。确认按钮倒计时 5 秒后才可点击。
 * @param {Vue} vm
 * @param {string} message
 * @returns {Promise}
 */
export function confirmDeleteOrder(vm, message) {
  let remain = DELAY_SECONDS
  let timer = null
  let closed = false

  const clearTimer = () => {
    closed = true
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }

  const render = () => {
    if (closed) return
    const locked = remain > 0
    const text = locked ? `确认删除（${remain}s）` : '确认删除'
    const boxVm = getBoxVm()
    if (boxVm) {
      boxVm.confirmButtonText = text
      boxVm.confirmButtonClass = locked ? 'is-disabled' : ''
      boxVm.$nextTick(() => {
        if (closed && locked) return
        lockButton(locked)
      })
      return
    }
    const box = getConfirmBox()
    const btn = box && box.querySelector('.el-message-box__btns .el-button--primary')
    if (!btn) return
    const label = btn.querySelector('span') || btn
    label.textContent = text
    if (locked) btn.classList.add('is-disabled')
    else btn.classList.remove('is-disabled')
    lockButton(locked)
  }

  const promise = vm.$confirm(message || '确定删除该订单吗？', '删除确认', {
    confirmButtonText: `确认删除（${DELAY_SECONDS}s）`,
    cancelButtonText: '取消',
    confirmButtonClass: 'is-disabled',
    customClass: 'order-delete-confirm',
    type: 'warning',
    closeOnClickModal: false,
    beforeClose(action, instance, done) {
      if (action === 'confirm' && remain > 0) return
      clearTimer()
      done()
    }
  })

  vm.$nextTick(() => {
    lockButton(true)
    timer = setInterval(() => {
      remain -= 1
      render()
      if (remain <= 0) clearTimer()
    }, 1000)
  })

  return promise.then(action => {
    clearTimer()
    return action
  }, err => {
    clearTimer()
    return Promise.reject(err)
  })
}
